import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  Input,
  Select,
  Stack,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { appContext } from "../../Context/AppContext";
import { useContext, useEffect, useState } from "react";
import {
  customerFilters,
  leadFilters,
  genderOptions,
  languagesOptions,
  budgetOptions,
  issuesOptions,
  leadStatus,
  customerStatus,
  systemUsageFilters,
} from "../../Config/filter";
import { MultiSelect } from "react-multi-select-component";
import CrmDataService from "../../services/data";
import Reachout from "../../services/Reachout";
import DateTimeModal from "../Modals/DateTImeModal";
import { DateTime } from "luxon";
import { useNavigate } from "react-router-dom";
import Notification from "../../services/Notification";
import { ClipLoader } from "react-spinners";
import TestModal from "../Modals/TestModal";

export const ReachoutTemplate = ({
  type,
  id,
  variableValues,
  whatsappImageUrl,
  whatsappVariables,
  setEmailVariables,
}: any) => {
  const navigate = useNavigate();
  const toast = useToast();
  const token = localStorage.getItem("logged_in_user_token");
  const { pageId } = useContext(appContext);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [modal, setModal] = useState("");
  const [reachoutId, setReachoutId] = useState("");

  const [campaignId, setCampaignId] = useState("");

  const [range, setRange] = useState({ start: "", end: "" });
  const [rangeError, setRangeError] = useState("");
  const [sortingOrder, setSortingOrder] = useState("ASC");

  const [source, setSource] = useState<any>([]);
  const [status, setStatus] = useState<any>([]);
  const [coldLeadsCount, setColdLeadsCount] = useState<any>();

  const [selectedSource, setSelectedSource] = useState<any>([]);
  const [selectedStatus, setSelectedStatus] = useState<any>([]);

  const [selectedLanguage, setSelectedLanguage] = useState<any>([]);
  const [selectedGender, setSelectedGender] = useState<any>([]);
  const [selectedBudget, setSelectedBudget] = useState<any>([]);
  const [selectedAgeGroup, setSelectedAgeGroup] = useState<any>([]);
  const [selectedIssues, setSelectedIssues] = useState<any>([]);
  const [selectedCampaigns, setSelectedCampaigns] = useState<any>([]);
  const [selectedSystemUsage, setSelectedSystemUsage] = useState<any>([]);
  const [excludeCampaigns, setExcludeCampaigns] = useState<any>([]);
  const [filteredCount, setFilteredCount] = useState<any>(0);
  const [filteredContacts, setFilteredContacts] = useState<any>([]);

  const [applyfiltersLoading, setApplyFiltersLoading] = useState(false);
  const [filterReachoutsLoading, setFilterReachoutsLoading] = useState(false);
  const [filtersApplied, setFiltersApplied] = useState(false);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [single_session_count, setSingleSessionCount] = useState<any>(null);

  const [isFromEhc, setIsFromEhc] = useState("no");

  const age_group = generateAgeRanges(18, 45, 5).map((item) => ({
    value: item,
    label: item,
  }));

  const sortingOrderOptions = [
    { value: "ASC", label: "Ascending" },
    { value: "DESC", label: "Descending" },
  ];

  function generateAgeRanges(
    minAge: number,
    maxAge: number,
    diff: number
  ): any[] {
    const ageRanges = [];

    ageRanges.push(`<${minAge}`);

    for (let i = minAge; i <= maxAge; i += diff) {
      const endAge = i + diff - 1;
      if (endAge <= maxAge) {
        ageRanges.push(`${i}-${endAge}`);
      } else {
        ageRanges.push(`${i}-${maxAge}`);
      }
    }

    ageRanges.push(`>${maxAge}`);

    return ageRanges;
  }

  const createReachout = () => {
    setApplyFiltersLoading(true);
    const source = selectedSource.map((el: { value: any }) => el.value);
    const status = selectedStatus.map((el: { value: any }) => el.value);
    const languages_known = selectedLanguage.map(
      (el: { value: any }) => el.value
    );
    const issues = selectedIssues.map((el: { value: any }) => el.value);
    const age_group = selectedAgeGroup.map((el: { value: any }) => el.value);
    const gender = selectedGender.map((el: { value: any }) => el.value);
    const budget = selectedBudget.map((el: { value: any }) => el.value);
    const system_age = selectedSystemUsage.map(
      (el: { value: any }) => el.value
    );

    const data = {
      template_id: id,
      filters: {
        source,
        languages_known,
        age_group,
        gender,
        budget,
        issues,
        status,
        system_age,
        single_session_count,
        isFromEhc,
      },
      type,
      status: "NOT_CONFIRMED",
      campaign_id: campaignId,
      contacts: filteredContacts,
      contacts_count: filteredCount,
    };

    Reachout.createReachoutNotification(data, fromDate, toDate)
      .then((res) => {
        setReachoutId(res.data._id);
        setApplyFiltersLoading(false);
        setFiltersApplied(true);
        toast({
          position: "top",
          title: "Filters Applied.",
          description: "Filters are applied successfully.",
          status: "success",
          duration: 1000,
          isClosable: true,
        });
      })
      .catch((error: any) => {
        if (error.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
        console.log(error);
      });
  };

  const updateReachout = async (send_mode: string) => {
    if (type === "email") {
      await Notification.updateEmailTemplate(id, variableValues).then(
        (res) => {}
      );
    } else if (type === "whatsapp") {
      await Notification.updateWhatsappTemplate(
        id,
        whatsappImageUrl,
        whatsappVariables
      ).then((res) => {});
    }

    const now = DateTime.now().setZone("Asia/Kolkata");

    const current_date = now.toFormat("yyyy-MM-dd");
    const current_time = now.toFormat("HH:mm");

    await Reachout.updateReachoutNotification(
      reachoutId,
      current_date,
      current_time,
      send_mode
    ).then((res) => {
      toast({
        position: "top",
        title: "Reachout Sent.",
        description: "Reachout is sent to users successfully.",
        status: "success",
        duration: 1000,
        isClosable: true,
      });
    });
  };

  const handleSendToTestUser = async () => {
    let notificationType: "whatsapp" | "email" | "notification";

    if (type === "whatsapp") {
      notificationType = "whatsapp";
    } else if (type === "email") {
      notificationType = "email";
    } else {
      notificationType = "notification";
    }

    let userIds: string[];

    if (type === "whatsapp") {
      userIds = ["8969963531", "9554840740", "7007829243", "7607471747"];
    } else if (type === "email") {
      userIds = [
        "kumarisweta.as@gmail.com",
        "ayushs@manoshala.com",
        "singhayush28321@manoshala.com",
        // "nishants@manoshala.com",
        "nish1997ns@gmail.com",
        // "ceooffice@manoshala.com",
        "kratika@manoshala.com",
        "kratikaagarwal1@gmail.com",
        "abhishek@manoshala.com",
        "abhisheksw4@gmail.com",
      ];
    } else {
      userIds = [
        "g8UburUl98Zj2G78fdZiVsmYeG43",
        "8merwrSzZjRS9fEZWhmVjLY6fuk2",
        "mR4bL1kCOOQ4qKbK5rlNNuSXXmd2",
        "u1AJIUq2hbYtGvIu04AgSbPGRiD2",
        "wdUXzFuNwVOwPOEPuMypvakfrxE2",
        "LBtD4WltjQd7Z6G8tENOJDwMiK02",
        "gOiHHnBePCXIKIV8IBtNUClNN8H3",
      ];
    }

    const testUsers = [
      {
        label: "Kratika Agrawal",
        userId: "kratika@manoshala.com",
        appUserId: "wdUXzFuNwVOwPOEPuMypvakfrxE2",
        phoneNumber: "7607471747",
      },
      {
        label: "Abhishek Kumar",
        userId: "abhishek@manoshala.com",
        appUserId: "mR4bL1kCOOQ4qKbK5rlNNuSXXmd2",
        phoneNumber: "",
      },
      {
        label: "Ayush Singh",
        userId: "singhayush28321@gmail.com",
        appUserId: "8merwrSzZjRS9fEZWhmVjLY6fuk2",
        phoneNumber: "9554840740",
      },
      {
        label: "Nishant Singh",
        userId: "nish1997ns@gmail.com",
        appUserId: "gOiHHnBePCXIKIV8IBtNUClNN8H3",
        phoneNumber: "7007829243",
      },
      {
        label: "Sweta Kumari",
        userId: "kumarisweta.as@gmail.com",
        appUserId: "g8UburUl98Zj2G78fdZiVsmYeG43",
        phoneNumber: "8969963531",
      },
    ];

    //send mode

    testUsers.forEach(async (testUser) => {
      if (type === "whatsapp") {
        notificationType = "whatsapp";
      } else if (type === "email") {
        await Notification.updateEmailTemplate(id, variableValues).then(
          (res) => {}
        );

        await Notification.sendDolphinActionNotification(
          "email",
          id,
          testUser.userId,
          testUser.appUserId
        ).then((res) => {
          toast({
            position: "top",
            title: "Email Sent.",
            description: "Email is sent to the user successfully.",
            status: "success",
            duration: 1000,
            isClosable: true,
          });
        });
      } else {
        await Notification.sendDolphinActionNotification(
          "notification",
          testUser.appUserId
        ).then((res) => {
          toast({
            position: "top",
            title: "App Notification Sent.",
            description: "App Notification is sent to the user successfully.",
            status: "success",
            duration: 1000,
            isClosable: true,
          });
        });
      }
    });
  };

  const getColdLeadCounts = () => {
    CrmDataService.getStatusCount().then((res) => {
      if (res.data) {
        setColdLeadsCount(res.data.COLD || "");
      }
    });
  };

  const filterReachouts = () => {
    setFilterReachoutsLoading(true);
    const source = selectedSource.map((el: { value: any }) => el.value);
    const status = selectedStatus.map((el: { value: any }) => el.value);
    const languages_known = selectedLanguage.map(
      (el: { value: any }) => el.value
    );
    const issues = selectedIssues.map((el: { value: any }) => el.value);
    const age_group = selectedAgeGroup.map((el: { value: any }) => el.value);
    const gender = selectedGender.map((el: { value: any }) => el.value);
    const budget = selectedBudget.map((el: { value: any }) => el.value);
    const campaign_ids = selectedCampaigns.map(
      (el: { value: any }) => el.value
    );
    const system_age = selectedSystemUsage.map(
      (el: { value: any }) => el.value
    );

    const data = {
      source,
      languages_known,
      age_group,
      gender,
      budget,
      issues,
      status,
      system_age,
      campaign_ids,
      single_session_count,
      isFromEhc,
    };

    Reachout.getFilteredReachoutCount(
      data,
      type,
      sortingOrder,
      range,
      "user",
      fromDate,
      toDate
    )
      .then((res) => {
        setFilteredCount(res.data.count);
        setFilterReachoutsLoading(false);
        if (type === "whatsapp") {
          const phoneNumbers = res.data.contacts.map(
            (contact: any) => contact.phone
          );
          setFilteredContacts(phoneNumbers);
        } else if (type === "email") {
          setFilteredContacts(res.data.contacts);
        } else {
          setFilteredContacts(res.data.contacts);
        }
      })
      .catch((error: any) => {
        toast({
          position: "top",
          title: "Apply Filters Failed.",
          description: "Filters are not applied.",
          status: "error",
          duration: 500,
          isClosable: true,
        });
        console.log(error);
      });
  };

  const handleSortingOrderChange = (event: any) => {
    const selectedOrder: any = sortingOrderOptions.find(
      (item: any) => item.value === event.target.value
    );

    setSortingOrder(selectedOrder?.value);
  };

  const handleRangeChange = (e: any) => {
    const { name, value } = e.target;
    const updatedRange = {
      ...range,
      [name]: value,
    };

    setRange(updatedRange);

    const start = parseInt(updatedRange.start);
    const end = parseInt(updatedRange.end);

    if (!isNaN(start) && !isNaN(end)) {
      if (end < start) {
        setRangeError(
          "End value must be greater than or equal to start value."
        );
      } else if (end - start > 250) {
        setRangeError("Range difference cannot exceed 250.");
      } else {
        setRangeError("");
      }
    } else {
      setRangeError("");
    }
  };
  function getSelectedOptions(optionsValue: any[], defaultValue: any[]) {
    // console.log("optionsValue",optionsValue);
    // console.log("defaultValue",defaultValue);
    // console.log("result",optionsValue.filter((option) => defaultValue.includes(option.value)));
    return optionsValue.filter((option) => defaultValue.includes(option.value));
  }
  const updateExistingCampaignFilter = (id: any) => {
    Reachout.getSingleCampaign(id)
      .then((res) => {
        const data = res.data;
        // console.log("res.data",data);

        if (data) {
          // console.log("data",data);
          const sourceOptions = (
            pageId === "leads-reachout" ? leadFilters : customerFilters
          ).map((item) => ({
            value: item,
            label: item,
          }));

          const statusOptions = (
            pageId === "leads-reachout" ? leadStatus : customerStatus
          ).map((item) => ({
            value: item,
            label: item,
          }));
          const {
            age_group,
            budget,
            campaign_ids,
            gender,
            issues,
            languages_known,
            source,
            status,
            system_age,
          } = data.filters;
          const ages = generateAgeRanges(18, 45, 5).map((item) => ({
            value: item,
            label: item,
          }));
          console.log(getSelectedOptions(sourceOptions, source));
          setSelectedSource(getSelectedOptions(sourceOptions, source));
          setSelectedStatus(getSelectedOptions(statusOptions, status));
          setSelectedLanguage(
            getSelectedOptions(languagesOptions, languages_known)
          );
          setSelectedIssues(getSelectedOptions(issuesOptions, issues));
          setSelectedAgeGroup(getSelectedOptions(ages, age_group));
          setSelectedGender(getSelectedOptions(genderOptions, gender));
          setSelectedBudget(getSelectedOptions(budgetOptions, budget));
          setSelectedCampaigns(
            getSelectedOptions(excludeCampaigns, campaign_ids)
          );
          setSelectedSystemUsage(
            getSelectedOptions(systemUsageFilters, system_age)
          );
          // console.log(res.data);
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  useEffect(() => {
    Reachout.getCampaigns()
      .then((res) => {
        const data = res.data;
        // console.log(res.data);
        const formatted = data.map((el: any) => ({
          value: el,
          label: el,
        }));
        setExcludeCampaigns(formatted);
      })
      .catch((error: any) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    filterReachouts();
  }, [
    type,
    selectedSource,
    selectedAgeGroup,
    selectedGender,
    selectedIssues,
    selectedBudget,
    selectedLanguage,
    selectedStatus,
    selectedSystemUsage,
    excludeCampaigns,
    range,
    sortingOrder,
    fromDate,
    toDate,
    single_session_count,
    isFromEhc
  ]);

  useEffect(() => {
    if (pageId === "leads-reachout") {
      setEmailVariables({
        name: "",
        gender: "",
        age: "",
        issues: [],
        expert: [],
        last_purchase_date: [],
        last_session_date: [],
        sessions_left: [],
        total_session_count: [],
      });
    } else if (pageId === "customer-reachout") {
      setEmailVariables({
        location: "",
        budget: "",
        ehc: "",
        issues: [],
        // manual_status_override: false,
      });
    }
  }, [pageId]);

  useEffect(() => {
    getColdLeadCounts();

    const sourceOptions = (
      pageId === "leads-reachout" ? leadFilters : customerFilters
    ).map((item) => ({
      value: item,
      label: item,
    }));

    const statusOptions = (
      pageId === "leads-reachout" ? leadStatus : customerStatus
    ).map((item) => ({
      value: item,
      label: item,
    }));

    const newStatusOptions =
      pageId === "leads-reachout"
        ? [
            { value: "HOT", label: "HOT" },
            { value: "WARM", label: "WARM" },
          ]
        : customerStatus.map((item) => ({
            value: item,
            label: item,
          }));

    setSource(sourceOptions);
    setSelectedSource(sourceOptions);

    setStatus(statusOptions);
    setSelectedStatus(newStatusOptions);

    setFilteredContacts([]);
    setFilteredCount(0);
  }, [pageId]);

  return (
    <>
      <Box position="relative">
        <Grid templateColumns="repeat(6, 1fr)" gap={20} p={10}>
          <GridItem colSpan={2}>
            <Stack spacing={8}>
              <FormControl>
                <FormLabel>
                  Apply the filter by choosing old campaigns
                </FormLabel>

                <Select
                  placeholder="Select"
                  // value={ca}
                  onChange={(e) => updateExistingCampaignFilter(e.target.value)}
                >
                  {excludeCampaigns?.map((option: any) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl>
                <FormLabel>Select Status</FormLabel>
                <MultiSelect
                  options={status}
                  labelledBy="Select"
                  onChange={setSelectedStatus}
                  value={selectedStatus}
                />
              </FormControl>
              {selectedStatus.some(
                (status: any) => status.value === "SINGLE"
              ) && (
                <FormControl>
                  <FormLabel>Enter the count of single sessions</FormLabel>
                  <Input
                    type="number"
                    name="single_session_count"
                    placeholder=""
                    value={single_session_count}
                    onChange={(e) => setSingleSessionCount(e.target.value)}
                  />
                </FormControl>
              )}
              {selectedStatus.some(
                (status: any) =>
                  status.value === "SINGLE" || status.value === "SUBSCRIPTION"
              ) && (
                <FormControl mb={4}>
                  <FormLabel>Is From EHC?</FormLabel>
                  <Select
                    placeholder="Select option"
                    value={isFromEhc}
                    onChange={(e) => setIsFromEhc(e.target.value)}
                  >
                    <option value="yes">True</option>
                    <option value="no">False</option>
                  </Select>
                </FormControl>
              )}
              {selectedStatus.some(
                (status: any) => status.value === "COLD"
              ) && (
                <>
                  <FormControl>
                    <FormLabel>Select Order Of System Age</FormLabel>

                    <Select
                      placeholder="Select"
                      value={sortingOrder}
                      onChange={handleSortingOrderChange}
                    >
                      {sortingOrderOptions?.map((option: any) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl>
                    <FormLabel>Enter Contact Range (Limit: 250)</FormLabel>
                    <div className="flex items-center gap-4">
                      <Input
                        type="number"
                        name="start"
                        placeholder="Start"
                        value={range.start}
                        onChange={handleRangeChange}
                      />
                      <span className="font-semibold">-</span>
                      <Input
                        type="number"
                        name="end"
                        placeholder="End"
                        value={range.end}
                        onChange={handleRangeChange}
                      />
                    </div>
                    {rangeError && <Text color="#327171">{rangeError}</Text>}
                  </FormControl>
                </>
              )}
              <FormControl>
                <FormLabel>Select Gender</FormLabel>
                <MultiSelect
                  options={genderOptions}
                  labelledBy="Select"
                  onChange={setSelectedGender}
                  value={selectedGender}
                />
              </FormControl>
              <FormControl>
                <FormLabel>Select Budget</FormLabel>
                <MultiSelect
                  options={budgetOptions}
                  labelledBy="Select"
                  onChange={setSelectedBudget}
                  value={selectedBudget}
                />
              </FormControl>
              <FormControl>
                <FormLabel>Select Issues</FormLabel>
                <MultiSelect
                  options={issuesOptions}
                  labelledBy="Select"
                  onChange={setSelectedIssues}
                  value={selectedIssues}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Enter Campaign Id</FormLabel>
                <Input
                  name="campaignId"
                  placeholder="Enter Id"
                  value={campaignId}
                  onChange={(e) => setCampaignId(e.target.value)}
                />
              </FormControl>
            </Stack>
          </GridItem>
          {modal === "filterDate" && (
            <DateTimeModal
              templateId={id}
              id={reachoutId}
              isOpen={isOpen}
              onClose={onClose}
              type={type}
              variableValues={variableValues}
              // func={getFilteredDate}
            />
          )}
          <GridItem colSpan={2}>
            <Stack spacing={8}>
              <FormControl>
                <FormLabel>From Date</FormLabel>
                <Input
                  value={fromDate}
                  type="date"
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </FormControl>
              <FormControl>
                <FormLabel>To Date</FormLabel>
                <Input
                  value={toDate}
                  type="date"
                  onChange={(e) => setToDate(e.target.value)}
                />
              </FormControl>
              <FormControl>
                <FormLabel>Select Source</FormLabel>
                <MultiSelect
                  options={source}
                  labelledBy="Select"
                  onChange={setSelectedSource}
                  value={selectedSource}
                />
              </FormControl>
              <FormControl>
                <FormLabel>Select Language</FormLabel>
                <MultiSelect
                  options={languagesOptions}
                  labelledBy="Select"
                  onChange={setSelectedLanguage}
                  value={selectedLanguage}
                />
              </FormControl>
              <FormControl>
                <FormLabel>Select Age Group</FormLabel>
                <MultiSelect
                  options={age_group}
                  labelledBy="Select"
                  onChange={setSelectedAgeGroup}
                  value={selectedAgeGroup}
                />
              </FormControl>
              {/* <FormControl>
                <FormLabel>Select System Usage</FormLabel>
                <MultiSelect
                  options={systemUsageFilters}
                  labelledBy="Select"
                  onChange={setSelectedSystemUsage}
                  value={selectedSystemUsage}
                />
              </FormControl> */}
              <FormControl>
                <FormLabel>Exclude Campaigns</FormLabel>
                <MultiSelect
                  options={excludeCampaigns}
                  labelledBy="Select"
                  onChange={setSelectedCampaigns}
                  value={selectedCampaigns}
                />
              </FormControl>
            </Stack>
          </GridItem>
          <GridItem colSpan={2}>
            <Box
              bg="#DBEEED"
              px={10}
              h={40}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              You are sending this message to {filteredCount} contacts.
            </Box>
          </GridItem>
          {/* <GridItem colSpan={2}>
            <Box
              bg="#DBEEED"
              display="flex"
              justifyContent="center"
              alignItems="center"
            ></Box>
          </GridItem> */}
        </Grid>
        <Flex gap={5} direction="row" mx={10}>
          <Button
            my={8}
            colorScheme="orange"
            onClick={() => {
              const isColdSelected = selectedStatus.some(
                (status: any) => status.value === "COLD"
              );

              if (!campaignId) {
                toast({
                  position: "top",
                  title: "Please enter the campaign id.",
                  status: "error",
                  duration: 3000,
                  isClosable: true,
                });
                return;
              }

              // if (isColdSelected && !range) {
              //   toast({
              //     position: "top",
              //     title: "Please enter the number of contacts.",
              //     status: "error",
              //     duration: 3000,
              //     isClosable: true,
              //   });
              //   return;
              // }

              createReachout();
            }}
          >
            <div style={{ marginLeft: "15px" }}>Apply Filters</div>
            <ClipLoader
              color="#327171"
              size={20}
              cssOverride={{
                visibility: applyfiltersLoading ? "visible" : "hidden",
              }}
            />
          </Button>
          <Button
            my={8}
            colorScheme="green"
            disabled={!filtersApplied}
            onClick={() => {
              setModal("filterDate");
              onOpen();
            }}
          >
            Schedule
          </Button>
          <Button
            my={8}
            colorScheme="green"
            disabled={!filtersApplied}
            onClick={() => updateReachout("user")}
          >
            Send
          </Button>
          <Button
            my={8}
            colorScheme="yellow"
            disabled={!filtersApplied}
            // onClick={() => {
            //   setModal("testModal");
            //   onOpen();
            // }}
            onClick={() => updateReachout("test")}
          >
            Send To Test User
          </Button>
          {modal === "testModal" && (
            <TestModal
              isOpen={isOpen}
              onClose={onClose}
              whatsappVariables={whatsappVariables}
              whatsappImageUrl={whatsappImageUrl}
              emailVariables={variableValues}
              templateId={id}
              type={type}
            />
          )}
        </Flex>
        {filterReachoutsLoading && (
          <Flex
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            justify="center"
            align="center"
            bg="rgba(255, 255, 255, 0.6)"
            zIndex={10}
          >
            <ClipLoader color="#327171" size={40} />
          </Flex>
        )}
      </Box>
    </>
  );
};
